// extracted by mini-css-extract-plugin
module.exports = {"skeleton-box":"style_skeleton-box__30TTV","skeleton-box--hexagon":"style_skeleton-box--hexagon__3ccRM","shimmer":"style_shimmer__2BHmm"};